export default "__VITE_ASSET__DastusxU__"